export default "__VITE_ASSET__DyFD2nIP__"